import { Plot, Donut, Pie, Radar, Funnel, Spectr } from '../Chart';
export { Plot, Donut, Pie, Radar, Funnel, Spectr };
export default { Plot, Donut, Pie, Radar, Funnel, Spectr };
window.bChart = {
  Plot,
  Donut,
  Pie,
  Radar,
  Funnel,
  Spectr,
};
